<template>
    <b-modal
            ref="modal"
            size="lg"
            :title="$t('email.account_assignments_title')"
            @hidden="$emit('hidden')"
            :visible="true"
            hide-footer
            no-close-on-esc
            no-close-on-backdrop
    >
        <div>
            <b-form-row class="mb-3">
                <b-col cols="8" offset="2">
                    <legend class="font-size-sm font-weight-bold">{{$t('email.users_with_email_account_access')}}</legend>
                    <div class="d-flex justify-content-between align-items-center mb-3">
                        <v-select :options="suggestedUsers" v-model="selectedUser" :disabled="busy" label="name" :placeholder="$t('email.select_user')" style="flex: 9;"/>
                        <button class="btn btn-light btn-sm ml-2" style="flex: 2" :disabled="!selectedUser || busy" @click.prevent="handleAdd">
                            <i class="fa fa-spinner fa-spin" v-if="busy"/><span v-else>Dodaj</span>
                        </button>
                    </div>

                    <div class="table-responsive">
                        <b-table striped hover show-empty
                                 class="table-xs hidden-header"
                                 :items="connectedUsers"
                                 :fields="fields"
                                 :empty-text="$t('email.no_results')"
                                 :empty-filtered-text="$t('email.no_results_found')"
                        >
                            <template slot='options' slot-scope="data">
                                <button type="button" @click.prevent="handleDelete(data.item.id)" :disabled="busy" class="btn btn-light btn-xs mr-1">
                                    <i class="icon-bin text-danger"/>
                                </button>
                            </template>
                        </b-table>
                    </div>
                </b-col>
            </b-form-row>
        </div>
    </b-modal>
</template>

<script>
    import {mapGetters} from "vuex";
    import ApiClient2 from '../../../../../services/ApiClient2'
    import vSelect from 'vue-select';
    import 'vue-select/dist/vue-select.css';
    import SystemNotificator from "../../../../../services/SystemNotificator";

    export default {
        name: "AssignmentsModal",
        components: { vSelect },
        props: {
            mailboxUuid: {
                type: String,
                required: false,
            }
        },
        created() {
            this.busy = true;
            Promise.all([
                this.getConnectedUsers(),
                this.getAvailableUsers()
            ])
            .finally(() => this.busy = false)
        },

        computed: {
            ...mapGetters('Auth', ['user']),
            connectedUsers() {
                return this.connectedUuids.map((connUser) => {
                    const user = this.allUsers.find(u => u.uuid === connUser);
                    return {
                        id: connUser,
                        name: user ? user.name : this.$t('email.no_data')
                    }
                });
            },

            /**
             * Zwraca listę jeszcze nie przypisanych użytkowników (bez zalogowanego usera)
             */
            suggestedUsers() {
                return this.allUsers.filter(u => !this.connectedUuids.includes(u.uuid) && u.uuid !== this.user.uuid)
            },
        },

        data() {
            return {
                busy: false,
                connectedUuids: [],
                selectedUser: null,
                allUsers: [],
                fields: [
                    {
                        key: 'name',
                        label: this.$t('email.full_name'),
                        class: 'min text-left'
                    },
                    {
                        key: 'options',
                        label: '',
                        class: 'min text-nowrap text-right'
                    }
                ],
            }
        },

        methods: {
            getConnectedUsers() {
                return ApiClient2.get(`mailbox/${this.mailboxUuid}`)
                    .then(({data}) => this.connectedUuids = data.users || [])
                    .catch(error => SystemNotificator.error({title: this.$t('email.fetching_users_error'), message: error.response.data.errors}));
            },

            getAvailableUsers() {
                ApiClient2.get('users')
                    .then(({data}) => this.allUsers = data)
                    .catch(() => this.allUsers = [])
            },

            handleDelete(userUuid) {
                this.busy = true;
                ApiClient2.delete(`/mailbox/${this.mailboxUuid}/user`, {
                    data: {userUuids: [userUuid]}
                })
                    .then(() => {
                        SystemNotificator.success({title: '', message: this.$t('email.access_removed')});
                        this.connectedUuids = this.connectedUuids.filter(uuid => uuid !== userUuid);
                    })
                    .catch(error => SystemNotificator.error({title: this.$t('_error'), message: error.response.data.errors}))
                    .finally(() => this.busy = false)
            },

            handleAdd() {
                this.busy = true;
                ApiClient2.post(`/mailbox/${this.mailboxUuid}/user`, {
                    userUuids: [this.selectedUser.uuid]
                })
                    .then(() => {
                        SystemNotificator.success({title: '', message: this.$t('email.access_granted')});
                        this.connectedUuids.push(this.selectedUser.uuid);
                        this.selectedUser = null;
                    })
                    .catch(error => SystemNotificator.error({title: this.$t('_error'), message: error.response.data.errors}))
                    .finally(() => this.busy = false)
            },
        }
    }
</script>

<style>
    table.hidden-header > thead {
        display: none;
    }
</style>